import { AxiosInstance } from "axios";
import {
  CompanyDto,
  CompanyWithCollaborativesDto,
  CompanyWithCollaborativesPageDto,
} from "../types/company/company-dto";
import {
  CreateCompanyPayload,
  SearchCompanyPagePayload,
  UpdateCompanyPayload,
} from "../types/company/company-payload";
import { IdDto } from "../types/id/id-dto";
import { ongBaseApi } from "./ong-base-api";
import { OngBaseResponse } from "./ong-base-response";

export enum CompanyApiUrl {
  Create = "/user/company",
  Update = "/user/company",
  Delete = "/user/company",
  GetById = "/user/company",
  GetByName = "/user/company/name",
  Search = "/user/companies",
  SearchAll = "/user/companies/all",
}

class CompanyApi {
  private _api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this._api = api;
  }

  async create(payload: CreateCompanyPayload): Promise<OngBaseResponse<IdDto>> {
    return await this._api.post(CompanyApiUrl.Create, payload);
  }

  async update(
    id: string,
    payload: UpdateCompanyPayload
  ): Promise<OngBaseResponse<null>> {
    return await this._api.patch(`${CompanyApiUrl.Update}/${id}`, payload);
  }

  async delete(id: string): Promise<OngBaseResponse<null>> {
    return await this._api.delete(`${CompanyApiUrl.Delete}/${id}`);
  }

  async getById(
    id: string
  ): Promise<OngBaseResponse<CompanyWithCollaborativesDto>> {
    return await this._api.get(`${CompanyApiUrl.GetById}/${id}`);
  }

  async getByName(name: string): Promise<OngBaseResponse<CompanyDto>> {
    return await this._api.get(`${CompanyApiUrl.GetByName}/${name}`);
  }

  async search(
    payload: SearchCompanyPagePayload
  ): Promise<OngBaseResponse<CompanyWithCollaborativesPageDto>> {
    return await this._api.get(CompanyApiUrl.Search, {
      params: payload,
    });
  }

  async searchAll(): Promise<
    OngBaseResponse<CompanyWithCollaborativesPageDto>
  > {
    return await this._api.get(CompanyApiUrl.SearchAll);
  }
}

export const companyApi = new CompanyApi(ongBaseApi);
